import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AdminClinicsAddPage } from './admin-clinics-add';

@NgModule({
  declarations: [
    AdminClinicsAddPage,
  ],
  imports: [
    IonicPageModule.forChild(AdminClinicsAddPage),
  ],
})
export class AdminClinicsAddPageModule {}



// WEBPACK FOOTER //
// ./src/pages/admin-clinics-add/admin-clinics-add.module.ts